import Organization from "../domain/Organization";
import User from "@/domain/User";
import Mail from "@/domain/Mail";
import Area from "@/domain/Area";
import Region from "@/domain/Region";
import * as Performs from '@/enums/perform.type'
import * as Clients from '@/enums/client.type'
import Moment from 'moment'
import _ from 'underscore'
import Perform from "@/domain/Perform";
import Unit from "@/domain/Unit";
import Branch from "@/domain/Branch";
import Template from "@/domain/template";
import GlobalUnit from "@/domain/GlobalUnit";
import GlobalOrganization from "@/domain/GlobalOrganization";
import GlobalUser from "@/domain/GlobalUser";
import RegistryPermission from "@/domain/RegistryPermission";

let mapClientType = (clientType) => {
    let keys = _.keys(Clients)
    let clientKey = _.find(keys, key => {
        return Clients[key].id === clientType.Id;
    })
    return Clients[clientKey];
}

let mapPerformType = (performType) => {
    let keys = _.keys(Performs)
    let performKey = _.find(keys, key => {
        return Performs[key].id === performType;
    })

    return Performs[performKey];
}

let mapPerformViewModel = (performViewModel) => {
    if (performViewModel) {
        let perform = new Perform()

        perform.id = performViewModel.Id;
        perform.createdOn = Moment(performViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
        perform.performedOn = Moment(performViewModel.PerformedOnStr, 'YYYY-MM-DD');
        perform.note = performViewModel.Note;
        perform.performType = mapPerformType(performViewModel.Type)
        perform.courier = performViewModel.Courier
        perform.postIndex = performViewModel.PostIndex
        perform.recipient = performViewModel.Recipient

        return perform
    }
    return null
}

let mapDateTime = dateTimeViewModel => {
    if (dateTimeViewModel)
        return Moment(dateTimeViewModel, 'YYYY-MM-DD HH-mm-ss')
    return null
}

let mapAreaViewModel = (areaViewModel) => {
    if (areaViewModel)
        return new Area(areaViewModel.Id, areaViewModel.Name)
    return null
}

let mapRegionViewModel = (regionViewModel) => {
    if (regionViewModel)
        return new Region(regionViewModel.Id, regionViewModel.Name)
    return null
}

let mapOrganizationViewModel = organizationViewModel => {
    if (organizationViewModel) {
        let organization = new Organization()

        organization.id = organizationViewModel.Id
        organization.inn = organizationViewModel.Inn
        organization.name = organizationViewModel.Name
        organization.address = organizationViewModel.Address
        organization.accountNumber  = organizationViewModel.AccountNumber
        organization.mfo = organizationViewModel.Mfo
        organization.vatRegCode = organizationViewModel.VatRegCode
        organization.pinfl = organizationViewModel.Pinfl
        organization.phoneNumber = organizationViewModel.PhoneNumber
        organization.userFullName = organizationViewModel.UserFullName
        organization.username = organizationViewModel.Username
        organization.password = organizationViewModel.Password
        organization.createdOn = Moment(organizationViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
        organization.contractNumber = organizationViewModel.ContractNumber
        organization.contractDateFrom = organizationViewModel.ContractDateFromStr ? Moment(organizationViewModel.ContractDateFromStr, 'YYYY-MM-DD HH-mm-ss') : null;
        organization.contractDateTo = organizationViewModel.ContractDateToStr ? Moment(organizationViewModel.ContractDateToStr, 'YYYY-MM-DD HH-mm-ss') : null;
        organization.contractSum = organizationViewModel.ContractSum;
        organization.sumForMail = organizationViewModel.SumForMail;
        organization.sumForOverPaged = organizationViewModel.SumForOverPaged;
        organization.contractSignerUnit = organizationViewModel.ContractorSignerUnitName
        organization.contractSignerUnitId = organizationViewModel.ContractorSignerUnitId
        organization.isActive = organizationViewModel.IsActive
        organization.createdMailsCount = organizationViewModel.CreatedMailsCount
        organization.sentMailsCount = organizationViewModel.SentMailsCount
        organization.unitsCount = organizationViewModel.UnitsCount
        organization.balance = organizationViewModel.Balance
        organization.isLtd = organizationViewModel.IsLtd
        organization.isNotified = organizationViewModel.IsNotified
        organization.branchName = organizationViewModel.BranchName
        organization.branchCode = organizationViewModel.BranchCode
        organization.hasContractWithGlobalUnit = organizationViewModel.HasContractWithGlobalUnit

        return organization
    }

    return null
}


let mapGlobalOrganizationViewModel = globalOrganizationViewModel => {
    if (globalOrganizationViewModel) {
        let globalorganization = new GlobalOrganization()

        globalorganization.id = globalOrganizationViewModel.Id
        globalorganization.inn = globalOrganizationViewModel.Inn
        globalorganization.name = globalOrganizationViewModel.Name
        globalorganization.address = globalOrganizationViewModel.Address
        globalorganization.accountNumber  = globalOrganizationViewModel.AccountNumber
        globalorganization.mfo = globalOrganizationViewModel.Mfo
        globalorganization.phoneNumber = globalOrganizationViewModel.PhoneNumber
        globalorganization.createdOn = Moment(globalOrganizationViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
        globalorganization.contractNumber = globalOrganizationViewModel.ContractNumber
        globalorganization.contractSignerGlobalUnit = globalOrganizationViewModel.ContractorSignerGlobalUnitName
        globalorganization.contractSignerGlobalUnitId = globalOrganizationViewModel.ContractorSignerGlobalUnitId
        globalorganization.isActive = globalOrganizationViewModel.IsActive
        globalorganization.createdMailsCount = globalOrganizationViewModel.CreatedMailsCount
        globalorganization.sentMailsCount = globalOrganizationViewModel.SentMailsCount
        globalorganization.unitsCount = globalOrganizationViewModel.UnitsCount

        return globalorganization
    }

    return null
}

let mapUserViewModel = userViewModel => {
    if (userViewModel) {
        let user = new User()

        user.id = userViewModel.Id
        user.name = userViewModel.Name
        user.username = userViewModel.Username
        user.organization = mapOrganizationViewModel(userViewModel.Organization)
        user.type = userViewModel.Type;
        user.canSignOnBehalfOfOrganization = userViewModel.CanSignOnBehalfOfOrganization;
        user.unitIds = userViewModel.UnitPermissionIds;

        if (userViewModel.Unit)
            user.unit = mapUnitViewModel(userViewModel.Unit)

        return user
    }

    return null
}

let mapGlobalUserViewModel = globalUserViewModel => {
    if (globalUserViewModel) {
        let globalUser = new GlobalUser()

        globalUser.id = globalUserViewModel.Id
        globalUser.name = globalUserViewModel.Name
        globalUser.username = globalUserViewModel.Username
        globalUser.globalorganization = mapGlobalOrganizationViewModel(globalUserViewModel.GlobalOrganization)
        globalUser.type = globalUserViewModel.Type;
        globalUser.canSignOnBehalfOfOrganization = globalUserViewModel.CanSignOnBehalfOfOrganization;

        if (globalUserViewModel.GlobalUnit)
            globalUser.globalunit = mapGlobalUnitViewModel(globalUserViewModel.GlobalUnit)

        return globalUser
    }

    return null
}

let mapUnitViewModel = unitViewModel => {
    if (unitViewModel) {
        let unit = new Unit()

        unit.id = unitViewModel.Id
        unit.name = unitViewModel.Name
        unit.isHead = unitViewModel.IsHead
        unit.address = unitViewModel.Address
        unit.organization = unitViewModel.Organization ? mapOrganizationViewModel(unitViewModel.Organization) : null
        unit.createdOn = Moment(unitViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');
        unit.contractNumber = unitViewModel.ContractNumber
        unit.contractDateFrom = unitViewModel.ContractDateFromStr ? Moment(unitViewModel.ContractDateFromStr, 'YYYY-MM-DD HH-mm-ss') : null;
        unit.contractDateTo = unitViewModel.ContractDateToStr ? Moment(unitViewModel.ContractDateToStr, 'YYYY-MM-DD HH-mm-ss') : null;
        unit.contractSum = unitViewModel.ContractSum;
        unit.sumForMail = unitViewModel.SumForMail;
        unit.sumForOverPaged = unitViewModel.SumForOverPaged;
        unit.isActive = unitViewModel.IsActive

        if (unitViewModel.Regions) {
            unit.regions = _.map(unitViewModel.Regions, r => {
                return mapRegionViewModel(r)
            })
        }

        return unit
    }
    return null
}

let mapGlobalUnitViewModel = globalUnitViewModel => {
    if (globalUnitViewModel) {
        let globalUnit = new GlobalUnit()

        globalUnit.id = globalUnitViewModel.Id
        globalUnit.name = globalUnitViewModel.Name
        globalUnit.isHead = globalUnitViewModel.IsHead
        globalUnit.address = globalUnitViewModel.Address
        globalUnit.globalorganization = globalUnitViewModel.GlobalOrganization ? mapGlobalOrganizationViewModel(globalUnitViewModel.GlobalOrganization) : null
        globalUnit.createdOn = Moment(globalUnitViewModel.CreatedOnStr, 'YYYY-MM-DD HH-mm-ss');

        if (globalUnitViewModel.Regions) {
            globalUnit.regions = _.map(globalUnitViewModel.Regions, r => {
                return mapRegionViewModel(r)
            })
        }

        return globalUnit
    }
    return null
}

let mapMailViewModel = mailViewModel => {
    if (mailViewModel) {
        let mail = new Mail()

        mail.id = mailViewModel.Id
        mail.receiver = mailViewModel.Receiver
        mail.address = mailViewModel.Address
        mail.area = mapAreaViewModel(mailViewModel.Area)
        mail.region = mapRegionViewModel(mailViewModel.Region)
        mail.pagesCount = mailViewModel.PagesCount
        mail.isSent = mailViewModel.IsSent
        mail.sentOn = mapDateTime(mailViewModel.SentOnStr)
        mail.createdOn = mapDateTime(mailViewModel.CreatedOnStr)
        mail.creatorUser = mapUserViewModel(mailViewModel.CreatorUser)
        mail.senderUser = mapUserViewModel(mailViewModel.SenderUser)
        mail.perform = mapPerformViewModel(mailViewModel.Perform)
        mail.isCharged = mailViewModel.IsCharged
        mail.chargedOn = mapDateTime(mailViewModel.ChargedOnStr)
        mail.sendStatus = mailViewModel.SendStatus

        return mail
    }

    return null
}

let mapBranchViewModel = branchViewModel => {
    if (branchViewModel) {
        let branch = new Branch()

        branch.id = branchViewModel.Id
        branch.branchName = branchViewModel.BranchName
        branch.branchCode = branchViewModel.BranchCode

        return branch
    }

    return null
}

let mapTemplateViewModel = TemplateViewModel => {
    if(TemplateViewModel)
    {
        let template = new Template()


        template.Id = TemplateViewModel.Id
        template.Name = TemplateViewModel.Name
        template.FileName = TemplateViewModel.FileName
        template.Organization = mapOrganizationViewModel(TemplateViewModel.Organization)

        return template;
    }
    return null
}

let mapRegistryPermissionViewModel = mapRegistryPermissionViewModel => {
    if(mapRegistryPermissionViewModel)
    {
        let registryPermission = new RegistryPermission()

        registryPermission.Id = mapRegistryPermissionViewModel.Id
        registryPermission.OrganizationId = mapRegistryPermissionViewModel.OrganizationId
        registryPermission.Organization = mapOrganizationViewModel(mapRegistryPermissionViewModel.Organization)
        registryPermission.UserId = mapOrganizationViewModel(mapRegistryPermissionViewModel.UserId)
        registryPermission.User = mapOrganizationViewModel(mapRegistryPermissionViewModel.User)

        return registryPermission;
    }
    return null
}

export default {
    mapOrganization: mapOrganizationViewModel,
    mapGlobalOrganization: mapGlobalOrganizationViewModel,
    mapUser: mapUserViewModel,
    mapRegistryPermission: mapRegistryPermissionViewModel,
    mapGlobalUser: mapGlobalUserViewModel,
    mapUnit: mapUnitViewModel,
    mapGlobalUnit: mapGlobalUnitViewModel,
    mapMail: mapMailViewModel,
    mapBranch: mapBranchViewModel,
    mapArea: mapAreaViewModel,
    mapRegion: mapRegionViewModel,
    mapPerformType: mapPerformType,
    mapClientType: mapClientType,
    mapTemplate: mapTemplateViewModel
}
